// src/components/PageNotFound.js
import React from 'react';
import { Container, Typography, Link, Box, Avatar } from '@mui/material';
 
const DownloadApp = () => {
    return (
        <Container maxWidth="lg" sx={{ mt: 4, mb: 4 }}>
            <Box sx={{ mt: '5%', display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
                <Avatar 
                alt="Logo" 
                src="logo_old.png" 
                variant="rounded" 
                sx={{
                    height: 450,
                    width: 450,
                    }} />
                <Typography variant="h2" gutterBottom>
                    IRP Inspect Reply Pro
                </Typography>
                
                <Link href={`//${process.env.REACT_APP_ANDROID_PACKAGE}`} target="_blank" rel="noopener noreferrer">
                    Download App for Android
                </Link>
                <br />
                <Link href={`//${process.env.REACT_APP_IOS_PACKAGE}`} target="_blank" rel="noopener noreferrer">
                    Download App for Apple
                </Link>
            </Box>            
        </Container>
    );
};
export default DownloadApp;